import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { WorkflowNodeModel } from '@smarttask-common/src/lib/models/Workflow/node/core/WorkflowNodeModel';

export enum WorkflowNodeActionTypes {
    ADD_NODE = '[WorkflowNode] Add Node',
    ADD_NODES = '[WorkflowNode] Add Nodes',
    UPSERT_NODE = '[WorkflowNode] Upsert Node',
    UPSERT_NODES = '[WorkflowNode] Upsert Nodes',
    UPDATE_NODE = '[WorkflowNode] Update Node',
    UPDATE_NODES = '[WorkflowNode] Update Nodes',
    DELETE_NODE = '[WorkflowNode] Delete Node',
    DELETE_NODES = '[WorkflowNode] Delete Nodes',
    DELETE_ALL = '[WorkflowNode] Delete All',

    UPDATE_SELECTED_ID = '[WorkflowNode] Update SelectedId',
}

export class UpdateSelectedNodeId implements Action {
    readonly type = WorkflowNodeActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_node_id: string) {}
}

export class AddOne implements Action {
    readonly type = WorkflowNodeActionTypes.ADD_NODE;
    constructor(public node: WorkflowNodeModel) {}
}

export class AddMany implements Action {
    readonly type = WorkflowNodeActionTypes.ADD_NODES;
    constructor(public nodes: Array<WorkflowNodeModel>) {}
}

export class UpsertOne implements Action {
    readonly type = WorkflowNodeActionTypes.UPSERT_NODE;
    constructor(public node: WorkflowNodeModel) {}
}

export class UpsertMany implements Action {
    readonly type = WorkflowNodeActionTypes.UPSERT_NODES;
    constructor(public nodes: Array<WorkflowNodeModel>) {}
}

export class UpdateOne implements Action {
    readonly type = WorkflowNodeActionTypes.UPDATE_NODE;
    constructor(public node: Update<WorkflowNodeModel>) {}
}

export class UpdateMany implements Action {
    readonly type = WorkflowNodeActionTypes.UPDATE_NODES;
    constructor(public nodes: Array<Update<WorkflowNodeModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = WorkflowNodeActionTypes.DELETE_NODE;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = WorkflowNodeActionTypes.DELETE_NODES;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = WorkflowNodeActionTypes.DELETE_ALL;
    constructor() {}
}

export type WorkflowNodeActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | UpdateOne
    | UpdateMany
    | DeleteOne
    | DeleteMany
    | DeleteState
    | UpdateSelectedNodeId;
